import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../../shared/services/loader.service';

/**
 * Set this header on a request to keep it out of the global page loader.
 *
 * The loader is a full-page blocking overlay, which is right for a navigation or a form
 * submit but wrong for an action that already reports progress in place — a button with its
 * own spinner, a row action in a table. Requests carrying this header show no overlay, and
 * the header is stripped before the request leaves the browser.
 */
export const SKIP_LOADER_HEADER = 'X-Skip-Loader';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.headers.has(SKIP_LOADER_HEADER)) {
      return next.handle(req.clone({ headers: req.headers.delete(SKIP_LOADER_HEADER) }));
    }

    this.loaderService.show();
    return next.handle(req).pipe(finalize(() => this.loaderService.hide()));
  }
}
